import { Box } from '@rbilabs/universal-components';

export const WalmartBadgeContainer = Box.withConfig(() => ({
  display: 'flex',
  alignItems: 'center',
  height: '$6',
  width: '$16',
}));
